var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"md":_vm.md,"cols":"12"}},[_c('v-text-field',{attrs:{"label":"ID","value":_vm.value,"type":"number","disabled":""},on:{"input":_vm.updateValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }